export const TreatmentInstanceOccurrenceType = {
  None: 'None',
  BundleVisit: 'BundleVisit',
  BundledVisit: 'BundledVisit',
  ConvertedToPhoneCall: 'ConvertedToPhoneCall',
  ConvertedFromOnSiteVisit: 'ConvertedFromOnSiteVisit',
};
